<template>
  <div>
    <Button
      v-tooltip.left="'Submit Feedback'"
      :icon="submitted ? 'pi pi-check' : 'pi pi-comments'"
      rounded
      raised
      aria-label="Submit Feedback"
      :class="['feedback-fab', { 'feedback-fab--submitted': submitted }]"
      :style="{ bottom: bottomOffset }"
      @click="open"
    />
    <FeedbackDialog
      :visible="isOpen"
      :is-submitting="isSubmitting"
      :can-submit="canSubmit"
      :submit-error="submitError"
      @close="close"
      @submit="onSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';
import FeedbackDialog from './FeedbackDialog.vue';
import { useFeedback } from './useFeedback';
import type { FeedbackConfig } from './types';

const props = withDefaults(defineProps<FeedbackConfig>(), {
  bottomOffset: 'var(--app-space-24)',
});

const { isOpen, isSubmitting, canSubmit, submitted, submitError, open, close, submit } = useFeedback(props);

async function onSubmit(data: { summary: string; description: string; files: File[] }) {
  await submit(data.summary, data.description, data.files);
  // submitError is set inside useFeedback on failure and passed to FeedbackDialog
}
</script>

<style scoped>
.feedback-fab {
  position: fixed;
  right: var(--app-space-24);
  z-index: 45;
  width: 48px;
  height: 48px;
}

.feedback-fab--submitted {
  background: var(--app-success-color, #16a34a);
}
</style>
